import { apiGet, apiPost, apiPut } from '.';
import {
  BareContentTemplate,
  NewContentTemplate,
  PaginateContentTemplateParams,
} from '../../../shared/types/contentTemplate';
import { Property } from '../../../shared/types/property';
import { FeedPage } from '@go-shared/types/feedTemplate';
import { PaginationResult } from '@go-shared/types/pagination';
import qs from 'query-string';

export async function getBrandContentTemplates(brandId: string): Promise<BareContentTemplate[]> {
  return apiGet(`/brand/${brandId}/content-template`);
}

export async function getPropertyContentTemplates(
  propertyId: string
): Promise<BareContentTemplate[]> {
  return apiGet(`/property/${propertyId}/content-template`);
}

export async function paginatePropertyContentTemplates(
  params: PaginateContentTemplateParams
): Promise<PaginationResult<BareContentTemplate>> {
  return apiGet(`/content-template/paginate?${qs.stringify(params)}`);
}

export async function create(contentTemplate: NewContentTemplate): Promise<BareContentTemplate> {
  return apiPost(`/brand/${contentTemplate.brand}/content-template`, contentTemplate);
}

export async function update(
  contentTemplate: BareContentTemplate,
  action?: 'promote' | 'demote'
): Promise<BareContentTemplate> {
  return apiPut(
    `/brand/${contentTemplate.brand}/content-template/${contentTemplate._id}`,
    contentTemplate,
    {
      action,
    }
  );
}

export async function setArchived(
  contentTemplate: BareContentTemplate
): Promise<BareContentTemplate> {
  return apiPut(
    `/brand/${contentTemplate.brand}/content-template/${contentTemplate._id}/archived`,
    contentTemplate
  );
}

export const updateFeedEditor = async (
  property: Property,
  sailingId: string,
  sailingDayId: string,
  currentPage: FeedPage,
  feedSlotNumber: number
) => {
  return apiPut(`/property/${property._id}/feed-editor/${sailingId}`, {
    currentPage,
    sailingDayId,
    feedSlotNumber,
  });
};

// TODO: IDE shows not usages, should this method be safe-deleted?
export const updateVenueRundown = (
  propertyId: string,
  venueRundownId: string,
  venueIds: string[],
  sailingId: string,
  sailingDayId: string
) => {
  return apiPut(
    `/property/${propertyId}/venue-rundown/${venueRundownId}/${sailingId}/${sailingDayId}`,
    {
      venues: venueIds,
    }
  );
};

// TODO: IDE shows not usages, should this method be safe-deleted?
export const updateVenueMealPeriods = (
  propertyId: string,
  venueMealPeriodsId: string,
  venueIds: string[],
  sailingId: string,
  sailingDayId: string
) => {
  return apiPut(
    `/property/${propertyId}/venue-meal-periods/${venueMealPeriodsId}/${sailingId}/${sailingDayId}`,
    {
      venues: venueIds,
    }
  );
};
/**
 * Generates a CSV file with the Content templates data
 */
export const exportContentTemplatesToCSV = (propertyId: string) => {
  return apiGet<{ location: string }>(`/property/${propertyId}/content-template/export-csv`);
};
